import React from "react";
import { Link } from "react-router-dom";
import { useCart } from "@/contexts/CartContext";
import { useAuth } from "@/contexts/AuthContext";
import ProductCard from "@/components/ProductCard";

export default function Wishlist() {
  const { wishlist } = useCart();
  const { user } = useAuth();

  return (
    <div className="ja-container py-16 md:py-24" data-testid="wishlist-page">
      <div className="text-center mb-16">
        <p className="ja-overline">Saved For Later</p>
        <h1 className="ja-serif text-5xl md:text-6xl mt-3 tracking-tight">Wishlist</h1>
      </div>
      {!user ? (
        <div className="text-center py-20"><Link to="/login" className="ja-btn">Sign in</Link></div>
      ) : wishlist.length === 0 ? (
        <div className="text-center py-20"><p className="ja-serif text-2xl mb-8">Nothing saved yet.</p><Link to="/shop" className="ja-btn">Browse Jewellery</Link></div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-12">
          {wishlist.map((p, i) => <ProductCard key={p.id} p={p} idx={i} />)}
        </div>
      )}
    </div>
  );
}
